export default __webpack_public_path__ + "static/media/AccordionDesktop.0b077877.png";